import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild,
} from '@angular/core';
import { Property, PropertyReserveStudy } from '../../shared/models';
import { ModalComponent } from 'app/internal/shared';
import { DxDataGridComponent } from 'devextreme-angular';
import { trigger } from 'devextreme/events';

@Component({
  selector: 'sp-reserve-study-edit',
  templateUrl: './reserve-study-edit.component.html',
  styleUrls: ['./reserve-study-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ReserveStudyEditComponent {
  @ViewChild('dxReserveStudyHistoryDataGrid', { static: false }) dxReserveStudyHistoryDataGrid: DxDataGridComponent;
  @ViewChild('updateReserveStudyModal', { static: true }) public updateReserveStudyModal: ModalComponent;
  @ViewChild('deleteReserveStudyModal', { static: true }) public deleteReserveStudyModal: ModalComponent;

  readonly allowedPageSizes = [10, 25, 50, 'all'];
  @Input() property: Property;
  @Input() reserveStudies: PropertyReserveStudy[];

  @Output() add = new EventEmitter<PropertyReserveStudy>();
  @Output() delete = new EventEmitter<PropertyReserveStudy>();
  @Output() update = new EventEmitter<PropertyReserveStudy>();

  reserveStudyToDelete: PropertyReserveStudy = null;
  reserveStudyToUpdate: PropertyReserveStudy = null;

  showEditModal(reserveStudy: PropertyReserveStudy) {
    this.reserveStudyToUpdate = reserveStudy;
    this.updateReserveStudyModal.show();
  }

  showDeleteModal(reserveStudy: PropertyReserveStudy) {
    this.reserveStudyToDelete = reserveStudy;

    this.deleteReserveStudyModal.show();
  }

  onAdd(reserveStudy: PropertyReserveStudy) {

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    reserveStudy.propertyId = this.property.propertyId,
    this.add.emit(reserveStudy);
  }

  onUpdate(reserveStudy: PropertyReserveStudy) {

    // reserveStudy.propertyId = this.property.propertyId,
    this.update.emit(reserveStudy);
  }

  onDelete() {
    this.delete.next(this.reserveStudyToDelete);
    this.reserveStudyToDelete = null;
  }

  rebuildDxGrid() {
    this.dxReserveStudyHistoryDataGrid.instance.refresh();
  }

  showActionMenu(e) {
    // This allows us to either left or right click to show the menu.
    const newEvent = Object.assign({}, e.event, { type: 'dxcontextmenu' });
    e.event.stopPropagation();
    trigger(e.element, newEvent);
  }

  onContextMenuPreparing(e) {

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;

    // Only show the Context Menu if the Menu Button is clicked!
    if (e.row.rowType === 'data' && e.column.cellTemplate === 'menu') {

      e.items = [
        {
          text: 'Edit',
          onItemClick: function () {
            that.showEditModal(e.row.data);
          }
        },
        {
          text: 'Delete',
          onItemClick: function () {
            that.showDeleteModal(e.row.data);
          }
        },
      ];
    }
  }

  dxGridRowPrepared(e) {
    if (e.rowType === 'data') {
      e.rowElement.style.height = '40px';
    }
  }

}
